
import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import FeaturedDeals from './components/FeaturedDeals';
import SignupSection from './components/SignupSection';
import Footer from './components/Footer';
import PrivacyModal from './components/PrivacyModal';
import TermsModal from './components/TermsModal';

function App() {
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [showTerms, setShowTerms] = useState(false);

  return (
    <Router>
      <div className="min-h-screen bg-white">
        <Header />
        <Routes>
          <Route path="/" element={
            <>
              <Hero />
              <FeaturedDeals />
              <SignupSection />
              <Footer 
                onShowPrivacy={() => setShowPrivacy(true)}
                onShowTerms={() => setShowTerms(true)}
              />
            </>
          } />
        </Routes>
        
        {showPrivacy && (
          <PrivacyModal onClose={() => setShowPrivacy(false)} />
        )}
        
        {showTerms && (
          <TermsModal onClose={() => setShowTerms(false)} />
        )}
      </div>
    </Router>
  );
}

export default App;
